module.exports = __webpack_public_path__ + "static/media/Food Processing Entreprise (CMN) - Desktop - 24-06-2024 N .f3dc44f8.gif";